Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "LandingPage";
exports.labelBodyText = "LandingPage Body";

exports.btnExampleTitle = "CLICK ME";
exports.connectText = "Connect"

exports.connectSectionDataAPiEndPoint = "bx_block_landingpage2/landingpages/connect_fetch";
exports.pitchSectionDataAPiEndPoint = "bx_block_landingpage2/landingpages/hubblemeet_pitch";
exports.testimonialsDataAPiEndPoint = "bx_block_landingpage2/landingpages/testimonials";
exports.footerDataAPiEndPoint = "bx_block_landingpage2/landingpages/footer_settings";

exports.urlGetPrivacyPolicy="bx_block_terms_and_conditions/terms_and_conditions/get_content?title=privacy_policy";
exports.urlGetTermsConditions = "bx_block_terms_and_conditions/terms_and_conditions/get_content?title=terms_and_condition";
// Customizable Area End